// extracted by mini-css-extract-plugin
export default {"article":"SwapPage_article__7tDNc","header":"SwapPage_header__matJl","title":"SwapPage_title__q06bV","action":"SwapPage_action__cohUL","description":"SwapPage_description__-xhNL"};